import { Observable, Observer } from 'rxjs';

import { Transaction } from '../transaction/transaction';

export abstract class MemoryMapCacheRepository<T> {
    private data: Map<string, T> = new Map<string, T>();

    abstract getKey(...args): string;

    load(key: string): Observable<Transaction<T>> {
        return new Observable((observer: Observer<Transaction<T>>) => {
            if (this.data.has(key)) {
                observer.next(Transaction.success(this.data.get(key)));
            }
            observer.complete();
        });
    }

    save(key: string, value: T): Observable<void> {
        return new Observable((observer: Observer<void>) => {
            this.data.set(key, value);
            observer.complete();
        });
    }

    remove(key: string): Observable<void> {
        return new Observable((observer: Observer<void>) => {
            this.data.delete(key);
            observer.complete();
        });
    }

    clear(): Observable<void> {
        return new Observable((observer: Observer<void>) => {
            this.data.clear();
            observer.complete();
        });
    }
}
